import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import InputFieldV2, { InputFieldV2Props } from '../InputFieldV2';

export interface InputFieldV2AdapterProps
  extends FieldRenderProps<string, HTMLElement>,
    InputFieldV2Props {
  inputOnChange?: (e: React.ChangeEvent<HTMLElement>) => void;
  onBlurFunction?: (e: React.ChangeEvent<HTMLElement>) => void;
}
/**
 * ```import InputFieldV2Adapter from '@zola/zola-ui/src/components/Form/InputFieldV2/InputFieldV2Adapter';```
 *
 * Use with `react-final-form`
 */
const InputFieldV2Adapter: React.FC<InputFieldV2AdapterProps> = ({
  input,
  meta,
  inputOnChange,
  onBlurFunction,
  ...rest
}) => {
  const hasError = meta && meta.touched && (meta.submitError || meta.error);
  const errorMessage = hasError ? meta.submitError || meta.error : '';
  const inputProps = {
    ...input,
    ...rest,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      input.onChange(e);
      // eslint-disable-next-line mdx/no-unused-expressions
      inputOnChange && inputOnChange(e);
    },
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
      input.onBlur(e);
      // eslint-disable-next-line mdx/no-unused-expressions
      onBlurFunction && onBlurFunction(e);
    },
    errorMessage,
  };
  return <InputFieldV2 {...inputProps} />;
};

export default InputFieldV2Adapter;
